var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 54,
    viewBox: "0 0 250 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-130.000000, -73.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(130.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#D9E1EC",
    strokeWidth: 1,
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 249,
    height: 53,
    rx: 10
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Helvetica-Bold, Helvetica",
    fontSize: 9,
    fontWeight: "bold",
    fill: "#4B587C"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 53,
    y: 20
  }, "PRODUCT HUNT")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Helvetica-Bold, Helvetica",
    fontSize: 16,
    fontWeight: "bold",
    fill: "#4B587C"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 52,
    y: 40
  }, "#2 Product of the Day")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33,16.364 L0.328,24.9 C0.202,25.158 0.335,25.32 0.755,25.24 L4.013,24.532 C4.07755234,24.5094173 4.14861896,24.5149617 4.20888789,24.5472826 C4.26915683,24.5796035 4.31309537,24.6357337 4.33,24.702 L5.797,27.709 C5.937,28.033 6.099,28.099 6.225,27.842 L10.485,18.908 L4.33,16.364 Z M16.67,16.364 L20.672,24.9 C20.805,25.158 20.665,25.32 20.245,25.24 L16.987,24.532 C16.9224353,24.5100506 16.8516562,24.5158869 16.7915589,24.5481157 C16.7314616,24.5803445 16.687439,24.6360738 16.67,24.702 L15.203,27.709 C15.063,28.033 14.908,28.099 14.775,27.842 L10.515,18.908 L16.67,16.364 Z",
    fill: "#DE7818",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.298,21.392 C9.298,21.399 9.284,21.392 9.269,21.392 C7.03578049,21.1442528 4.94208026,20.1826237 3.299,18.65 C3.291,18.642 3.269,18.635 3.276,18.627 L3.46,18.237 C3.468,18.222 3.482,18.259 3.49,18.267 C5.067,19.733 7.257,20.655 9.497,20.927 C9.505,20.927 9.52,20.927 9.52,20.935 L9.298,21.392 Z",
    fill: "#B35454"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B9B9B",
    cx: 10.5,
    cy: 10.489,
    r: 10.489
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#949494",
    cx: 10.5,
    cy: 10.489,
    r: 9.045
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B6B6B6",
    cx: 10.75,
    cy: 10.75,
    r: 8.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19,9.018 L7.19,9.054 L9.159,9.054 L9.159,9.013 C9.159,8.315 9.663,7.823 10.389,7.823 C11.086,7.823 11.544,8.239 11.544,8.86 C11.544,9.358 11.227,9.786 9.984,10.934 L7.314,13.448 L7.314,14.884 L13.741,14.884 L13.741,13.208 L10.178,13.208 L10.178,13.097 L11.573,11.813 C13.073,10.477 13.623,9.645 13.623,8.708 C13.623,7.214 12.358,6.2 10.465,6.2 C8.503,6.2 7.19,7.337 7.19,9.018 Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.97,3.089 C16.3260745,3.89113363 18.7213186,6.85251327 18.8041673,10.3021205 C18.8870161,13.7517278 16.6366978,16.8246793 13.323,17.787 C15.358,16.232 16.707,13.578 16.707,10.563 C16.707,7.379 15.203,4.6 12.969,3.089 L12.97,3.089 Z",
    fillOpacity: 0.2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.702,21.392 C11.709,21.399 11.724,21.392 11.731,21.392 C14.024,21.104 16.131,20.182 17.717,18.664 C17.724,18.657 17.746,18.65 17.739,18.642 L17.554,18.252 C17.547,18.237 17.532,18.274 17.524,18.281 C15.947,19.748 13.751,20.655 11.503,20.927 C11.495,20.927 11.48,20.927 11.48,20.935 L11.702,21.392 Z",
    fill: "#B35454"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImg);
export default __webpack_public_path__ + "static/media/card-img.2a465c7f495aafa11e34e655e2ed23a1.svg";
export { ForwardRef as ReactComponent };